module.exports = __webpack_public_path__ + "img/spoon.be5030ca.webp";